import { useState, useEffect } from "react"
import Button from "../ui/Button"
import FormInput from "../ui/FormInput"
import FormSection from "../ui/FormSection"
import EditableTable from "../ui/EditableTable"
import Modal from "../ui/Modal"
import { v4 as uuidv4 } from "uuid"
import State, { STATE, CurrentEntityState, CurrentStudyState } from "@state";
import StudyController from "@/network/controllers/study.controller"


export default function SiteSettings({ onNext }) {
  const [initialLocalData, setInitialLocalData] = useState({})
  const [sites, setSites] = useState([])
  //const [showIcfModal, setShowIcfModal] = useState(false)
  // Modal pour la finalisation de l'étude
  const [isFinalizing, setIsFinalizing] = useState(false)
  const [currentIcf, setCurrentIcf] = useState({ link: "", name: "" })
  const [newSite, setNewSite] = useState({
    masterIcfVersionId: "",
    siteName: "",
    siteAddress: "",
    siteIcfFileName: "",
    siteIcfFile: null,
  })
  const [selectedMasterIcf, setSelectedMasterIcf] = useState("")
  const [uploadedFileName, setUploadedFileName] = useState("")
  const [uploadedFile, setUploadedFile] = useState(null);

  


  const [showEditICFModal, setShowEditICFModal] = useState(false)
  const [currentEditingSite, setCurrentEditingSite] = useState(null)
  const [newICFLink, setNewICFLink] = useState("")
  const [newICFFile, setNewICFFile] = useState(null)

  async function checkStudyExists(studyId) {
    const result = await StudyController.studyExist(studyId)
    if (!result.success) {
      throw new Error(result.message || "Study existence check failed")
    }
    return result.exists
  }


  useEffect(() => {
    const initialData = {
      name: STATE[CurrentStudyState.STUDY].name,
      estimatedDuration: STATE[CurrentStudyState.STUDY].estimatedDuration,
      thresholdOfParticipants: STATE[CurrentStudyState.STUDY].thresholdOfParticipants,
      masterIcfs: STATE[CurrentStudyState.MASTER_ICFS],
      milestones: STATE[CurrentStudyState.MILESTONES],
      sites: STATE[CurrentStudyState.SITES],
      studyManagers: STATE[CurrentStudyState.CRO_MANAGERS],
      investigators: STATE[CurrentStudyState.INVESTIGATORS],
    }
    setInitialLocalData(initialData)
    setSites(STATE[CurrentStudyState.SITES])
    console.log('=== initialData === SiteSettings.jsx === key: 888476 ===');
    console.dir(initialData, { depth: null, colors: true })
    console.log('=================================');
  }, [])

  const handleViewICF = (linkOrFileName, siteName) => {
    const site = sites.find((s) => s.siteName === siteName)
    let fileLink = linkOrFileName
  
    if (!isValidUrl(linkOrFileName) && site?.siteIcfFile instanceof File) {
      fileLink = URL.createObjectURL(site.siteIcfFile)
    }
  
    // Open in new browser tab
    window.open(fileLink, '_blank', 'noopener,noreferrer')
  }

  const handleEditICF = (site, currentLink) => {
    console.log("handleEditICF called with:", site, currentLink)
    setCurrentEditingSite(site)
    setNewICFLink(currentLink || "")
    setNewICFFile(site?.siteIcfFile ?? null)
    setShowEditICFModal(true)
  }

  const resetEditICFState = () => {
    setShowEditICFModal(false)
    setCurrentEditingSite(null)
    setNewICFLink("")
    setNewICFFile(null)
  }

  const handleSaveICF = () => {
    if (!currentEditingSite || !newICFLink) {
      return
    }

    const updatedSites = sites.map((site) => {
      if (site.tmpId !== currentEditingSite.tmpId) {
        return site
      }

      const updatedSite = {
        ...site,
        siteIcfFileName: newICFLink,
      }

      if (newICFFile instanceof File) {
        updatedSite.siteIcfFile = newICFFile
      } else if (isValidUrl(newICFLink)) {
        updatedSite.siteIcfFile = null
      }

      return updatedSite
    })

    setSites(updatedSites)
    const study = STATE[CurrentStudyState.STUDY]
    study.sites = updatedSites
    State.setValue(CurrentStudyState.STUDY, study)
    State.setValue(CurrentStudyState.SITES, updatedSites)
    //onUpdateStudyData({ sites: updatedSites })

    resetEditICFState()
  }

  const isValidUrl = (string) => {
    try {
      new URL(string)
      return true
    } catch (_) {
      return false
    }
  }

  // Define columns for the EditableTable
  const columns = [
    { key: "masterIcfVersionId", header: "Master ICF version", width: "25%" },
    { key: "siteName", header: "Site name", width: "25%" },
    { key: "siteAddress", header: "Site address", width: "30%" },
    { key: "siteIcfFileName", header: "View site ICF", width: "20%" },
  ]

  // Custom cell renderer for special cells like the ICF link
  const renderCell = (key, item, value, onChange, isEditMode) => {
    if (key === "masterIcfVersionId") {
      if (isEditMode) {
        return (
          <div className="relative">
            <select
              value={value || ""}
              onChange={(e) => onChange && onChange(e.target.value)}
              className="w-full px-3 py-2 bg-white  border border-gray-300 rounded-md appearance-none focus:outline-none"
            >
              {initialLocalData.masterIcfs && initialLocalData.masterIcfs.length > 0 ? (
                initialLocalData.masterIcfs.map((icf) => (
                  <option key={icf.tmpId} value={icf.name}>
                    {icf.name}
                  </option>
                ))
              ) : (
                <option value="">No Master ICF available</option>
              )}
            </select>
            <div className="absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none">
              <svg className="w-5 h-5 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 9l-7 7-7-7"></path>
              </svg>
            </div>
          </div>
        )
      } else {
        return value || ""
      }
    }

    if (key === "siteIcfFileName") {
      if (isEditMode) {
        if (value) {
          return (
            <div className="flex justify-center">
              <Button variant="createstudy" className="px-4 py-2" onClick={() => handleEditICF(item, value)}>
                Edit site ICF
              </Button>
            </div>
          )
        } else {
          return (
            <div className="flex gap-2">
              <input
                type="text"
                value={value || ""}
                onChange={(e) => onChange(e.target.value)}
                className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
                placeholder="Enter ICF link or upload file"
              />
              <div className="relative">
                <Button variant="createstudy" className="px-2 py-1 text-xs">
                  Upload
                </Button>
                <input
                  type="file"
                  className="absolute inset-0 opacity-0 cursor-pointer"
                  onChange={(e) => {
                    const file = e.target.files[0]
                    if (file) {
                      onChange(file.name)
                    }
                  }}
                  accept=".pdf,.doc,.docx"
                />
              </div>
            </div>
          )
        }
      } else {
        return value ? (
          <button
            className="text-blue-600 hover:underline font-medium"
            onClick={(e) => {
              e.stopPropagation()
              handleViewICF(value, item.siteName)
            }}
            type="button"
          >
            View site ICF
          </button>
        ) : (
          "No ICF uploaded"
        )
      }
    }

    return isEditMode ? (
      <input
        type="text"
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
      />
    ) : (
      value
    )
  }

  // Handle input change for new site form
  const handleInputChange = (e) => {
    const { name, value } = e.target
    setNewSite((prev) => ({
      ...prev,
      [name]: value,
    }))
  }

  // Handle master ICF selection
  const handleMasterICFChange = (e) => {
    setSelectedMasterIcf(e.target.value)
    setNewSite((prev) => ({
      ...prev,
      masterIcfVersionId: e.target.value,
    }))
  }

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUploadedFileName(file.name);
      setUploadedFile(file);
      setNewSite((prev) => ({
        ...prev,
        siteIcfFileName: file.name,
        siteIcfFile: file,
      }));
    }
  
    e.target.value = "";
  };
  
  

  // Add new site
const handleAddSite = () => {
  if (newSite.siteName && newSite.siteAddress) {
  
    if (!newSite.siteIcfFileName && uploadedFileName) {
      newSite.siteIcfFileName = uploadedFileName;
    }

  
    if (!newSite.siteIcfFile && uploadedFile) {
      newSite.siteIcfFile = uploadedFile;
    }

    const icfFileName = newSite.siteIcfFileName || "";

    
    const fallbackFile = sites.find(
      (s) =>
        s.siteIcfFileName === icfFileName &&
        s.siteIcfFile instanceof File
    )?.siteIcfFile;

    console.log("🔍 New site input:", newSite);
    console.log("📁 ICF filename resolved:", icfFileName);
    console.log("🔁 Matched fallback file:", fallbackFile?.name);

    const newSiteWithId = {
      ...newSite,
      tmpId: uuidv4(),
      masterIcfVersionId: selectedMasterIcf || initialLocalData.masterIcfs[0]?.name || "",
      masterIcfId: initialLocalData.masterIcfs[0]?.tmpId || "",
      studyId: STATE[CurrentStudyState.STUDY].tmpId,
      siteIcfFileName: icfFileName,
      siteIcfFile: newSite.siteIcfFile || fallbackFile || null,
    };

    if (!newSiteWithId.siteIcfFile && icfFileName && !isValidUrl(icfFileName)) {
      console.warn(`⚠️ No actual file found for site "${newSite.siteName}" with name "${icfFileName}"`);
    }

    const updatedSites = [...sites, newSiteWithId];
    setSites(updatedSites);

    const study = STATE[CurrentStudyState.STUDY];
    study.sites = updatedSites;
    State.setValue(CurrentStudyState.STUDY, study);
    State.setValue(CurrentStudyState.SITES, updatedSites);

    setNewSite({
      masterIcfVersionId: selectedMasterIcf,
      siteName: "",
      siteAddress: "",
      siteIcfFileName: "",
      siteIcfFile: null,
    });
    setUploadedFileName("");
    setUploadedFile(null);


    console.log("✅ Site added successfully:", newSiteWithId);
  }
};

  
  // Handle edit site
  const handleEditSite = (updatedSite) => {
    const updatedSites = sites.map((site) => (site.tmpId === updatedSite.tmpId ? updatedSite : site))

    setSites(updatedSites)
    const study = STATE[CurrentStudyState.STUDY]
    study.sites = updatedSites
    State.setValue(CurrentStudyState.STUDY, study)
    State.setValue(CurrentStudyState.SITES, updatedSites)
    //onUpdateStudyData({ sites: updatedSites })
  }

  // Handle delete site
  const handleDeleteSite = (site) => {
    const updatedSites = sites.filter((s) => s.tmpId !== site.tmpId)
    setSites(updatedSites)
    const study = STATE[CurrentStudyState.STUDY]
    study.sites = updatedSites
    State.setValue(CurrentStudyState.STUDY, study)
    State.setValue(CurrentStudyState.SITES, updatedSites)
    //onUpdateStudyData({ sites: updatedSites })
  }

  // Handle reorder sites
  const handleReorderSites = (oldIndex, newIndex) => {
    const updatedSites = [...sites]
    const [movedItem] = updatedSites.splice(oldIndex, 1)
    updatedSites.splice(newIndex, 0, movedItem)
    setSites(updatedSites)
    const study = STATE[CurrentStudyState.STUDY]
    study.sites = updatedSites
    State.setValue(CurrentStudyState.STUDY, study)
    State.setValue(CurrentStudyState.SITES, updatedSites)
    //onUpdateStudyData({ sites: updatedSites })
  }
  const validateSites = () => {
    if (sites.length === 0) {
      alert("Please add at least one site.");
      return false;
    }
  
    for (const site of sites) {
      if (!site.siteName || !site.siteAddress || !site.masterIcfVersionId) {
        alert("All site fields (Name, Address, Master ICF Version) must be filled for all sites.");
        return false;
      }
  
      if (site.siteIcfFileName) {
        if (!isValidUrl(site.siteIcfFileName)) {
          if (!site.siteIcfFile) {
            alert(
              `Site "${site.siteName}" has a file name for ICF but no actual file uploaded. Please upload the ICF file or provide a valid link.`
            );
            return false;
          }
        }
      } else {
        alert(`Site "${site.siteName}" requires a Site ICF link or an uploaded file.`);
        return false;
      }
    }
  
    return true;
  };
  

  
  // Continue to next step
  const handleContinue = async () => {

    if (!validateSites()) {
      return 
    }
    // Affiche la modale de finalisation
    setIsFinalizing(true)
    const study = STATE[CurrentStudyState.STUDY]
    study.sites = sites
    State.setValue(CurrentStudyState.STUDY, study)
    State.setValue(CurrentStudyState.SITES, sites)
    console.log("=== STATE === SiteSettings.jsx === key: 250586 ===")
    console.dir(STATE, { depth: null, colors: true })
    console.log("=================================")

    const studyId = STATE[CurrentStudyState.STUDY]?.tmpId
    let intervalId

    

    try {
      // 1. Wait for the study to exist in the backend
      await new Promise((resolve, reject) => {
        intervalId = setInterval(async () => {
          try {
            console.log(`Polling for study existence: ${studyId}`)
            if (await checkStudyExists(studyId)) {
              clearInterval(intervalId)
              resolve()
            }
          } catch (e) {
            clearInterval(intervalId)
            reject(e)
          }
        }, 5000) // Poll every 5 seconds
      })

      // 2. Once study exists, proceed with patching protocol versions and sites
      console.log("Study exists, proceeding with site and protocol updates.")

      const resp = await StudyController.queuePatchProtocolVersions()
      console.log("=== resp === SiteSettings.jsx === key: 213324 ===")
      console.dir(resp, { depth: null, colors: true })
      console.log("=================================")

      const resp2 = await StudyController.queuePatchSites()
      console.log("=== resp2 === SiteSettings.jsx === key: 162565 ===")
      console.dir(resp2, { depth: null, colors: true })
      console.log("=================================")

      // 3. Close modal and proceed to next step
      setIsFinalizing(false)
      onNext()
    } catch (error) {
      console.error("Error in handleContinue (SiteSettings):", error)
      alert("An error occurred while finalizing study sites.")
      setIsFinalizing(false) // Ensure modal closes on error
    } finally {
      if (intervalId) {
        clearInterval(intervalId) // Ensure interval is cleared even if promise is rejected
      }
    }
  }

  return (
    <div>
      <h2 className="mb-6 text-xl font-semibold">Site settings</h2>
  
      {/* Table wrapper: prevent horizontal clipping on small screens */}
      <div className="mb-8 -mx-2 sm:mx-0">
      <div className="overflow-x-auto px-3 sm:px-0" style={{ scrollbarGutter: "stable both-edges" }}>
      <div className="min-w-[1120px] sm:min-w-[1120px] md:min-w-[1180px]">
            <EditableTable
              items={sites}
              columns={columns}
              onEdit={handleEditSite}
              onDelete={handleDeleteSite}
              onReorder={handleReorderSites}
              emptyMessage="No sites have been recorded yet. They will appear in the table once added"
              saveModalTitle="Save site changes"
              saveModalMessage="You are about to save the modifications made to the sites. These changes will be applied to the study."
              cancelModalTitle="Discard site changes"
              cancelModalMessage="You are about to discard all modifications made to the sites."
              deleteModalTitle="Delete site"
              deleteModalMessage="You are about to permanently delete this site from the study."
              renderCell={renderCell}
            />
          </div>
        </div>
      </div>
  
      {currentIcf.link && (
        <div className="mt-4 mb-8 rounded-lg border border-gray-300 bg-white p-4 shadow-md">
          <h3 className="mb-2 text-lg font-semibold">
            Viewing ICF for: <span className="text-blue-600">{currentIcf.name}</span>
          </h3>
          {/* Responsive iframe height without changing colors */}
          <div className="h-[60vh] max-h-[720px] w-full overflow-hidden rounded-md border">
            <iframe
              src={currentIcf.link}
              title={`ICF for ${currentIcf.name}`}
              className="h-full w-full"
              sandbox="allow-same-origin allow-scripts"
            />
          </div>
        </div>
      )}
  
      {/* Add Site Form */}
      <FormSection title="Add site" className="rounded-lg p-4">
        <div className="mb-6 grid grid-cols-1 gap-6 sm:grid-col-1 md:grid-cols-2">
          {/* Master ICF Version */}
          <div className="min-w-0">
            <label className="mb-1 block text-sm font-medium text-gray-700">Select Master ICF Version</label>
            <select
              name="masterIcfVersionId"
              value={selectedMasterIcf}
              onChange={handleMasterICFChange}
              className="w-full rounded-md border border-gray-300 bg-white px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
            >
              {initialLocalData.masterIcfs && initialLocalData.masterIcfs.length > 0 ? (
                initialLocalData.masterIcfs.map((icf) => (
                  <option key={icf.tmpId} value={icf.name}>
                    {icf.name}
                  </option>
                ))
              ) : (
                <option value="">No Master ICF available</option>
              )}
            </select>
          </div>
  
          {/* Site Name */}
          <div className="min-w-0">
            <FormInput
              label="Site Name"
              name="siteName"
              value={newSite.siteName}
              onChange={handleInputChange}
              placeholder="Site Name"
            />
          </div>
        </div>
  
        <div className="mb-6 grid grid-cols-1 gap-6 md:grid-cols-2">
          {/* Site Address */}
          <div className="min-w-0">
            <FormInput
              label="Site address"
              name="siteAddress"
              value={newSite.siteAddress}
              onChange={handleInputChange}
              placeholder="Street, Number, City, Postal Code, Country"
            />
          </div>
  
          {/* Link to site ICF */}
          <div className="min-w-0">
            <label className="mb-1 block text-sm font-medium text-gray-700">Link to site ICF</label>
            {/* Stack on mobile, row on ≥sm; prevents the "Upload" button from overflowing */}
            <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
              <input
                type="text"
                name="siteIcfFileName"
                value={newSite.siteIcfFileName || uploadedFileName}
                onChange={handleInputChange}
                placeholder="Site ICF link"
                className="min-w-0 flex-1 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
              />
              <div className="relative shrink-0">
                {/* Button grows full width on mobile, auto on larger screens */}
                <Button variant="addbutton" className="w-full px-4 py-2 sm:w-auto">
                  Upload site ICF
                </Button>
                {/* Invisible file input covering the button; stays within bounds */}
                <input
                  type="file"
                  className="absolute inset-0 cursor-pointer opacity-0"
                  onChange={handleFileUpload}
                  accept=".pdf,.doc,.docx"
                />
              </div>
            </div>
          </div>
        </div>
  
        {/* Add Site Button: full width on mobile */}
        <Button onClick={handleAddSite} variant="addbutton" className="w-full sm:w-auto">
          Add site
        </Button>
      </FormSection>
  
      {/* Navigation Buttons */}
      <div className="p-4">
        <div className="flex flex-col items-stretch gap-3 sm:flex-row sm:justify-end">
          {/* <Button onClick={onPrev} variant="createstudy" className="px-8 py-2">Back</Button> */}
          <Button onClick={handleContinue} variant="createstudy" className="w-full px-6 py-2 sm:w-auto">
            Continue
          </Button>
        </div>
      </div>
  
      {/* Finalizing modal */}
      <Modal
        isOpen={isFinalizing}
        onClose={() => {}}
        title="Finalizing study..."
        hideCloseButton
        size="md"
      >
        <div className="flex flex-col items-center gap-4 p-6">
          <svg className="h-8 w-8 animate-spin text-blue-600" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
          </svg>
          <p className="text-center">Please wait while we finalize your study…</p>
        </div>
      </Modal>
  
      {/* Edit ICF modal */}
      <Modal
        isOpen={showEditICFModal}
        onClose={resetEditICFState}
        title="Edit Site ICF"
        primaryAction={handleSaveICF}
        primaryActionLabel="Save Changes"
        secondaryAction={resetEditICFState}
        secondaryActionLabel="Cancel"
        size="lg"
      >
        <div className="p-4">
          <p className="mb-4">Update the ICF link for {currentEditingSite?.siteName}</p>
          {/* Same responsive pattern as above to prevent overflow */}
          <div className="flex flex-col gap-2 sm:flex-row sm:items-center">
            <input
              type="text"
              value={newICFLink}
              onChange={(e) => setNewICFLink(e.target.value)}
              placeholder="Enter ICF link"
              className="min-w-0 flex-1 rounded-md border border-gray-300 px-3 py-2 focus:outline-none focus:ring-2 focus:ring-[#5B93FF]"
            />
            <div className="relative shrink-0">
              <Button variant="createstudy" className="w-full px-2 py-1 text-xs sm:w-auto">
                Upload
              </Button>
              <input
                type="file"
                className="absolute inset-0 cursor-pointer opacity-0"
                onChange={(e) => {
                  const file = e.target.files[0]
                  if (file) {
                    setNewICFLink(file.name)
                    setNewICFFile(file)
                  }
                }}
                accept=".pdf,.doc,.docx"
              />
            </div>
          </div>
        </div>
      </Modal>
    </div>
  );
              }
 {/* Modale ICF */}
     {/*  <Modal
        isOpen={showIcfModal}
        onClose={() => setShowIcfModal(false)}
        title={`Site ICF - ${currentIcf.name}`}
        primaryAction={() => setShowIcfModal(false)}
        primaryActionLabel="Close"
        size="xl"
      >
        <div className="p-4">
          {isValidUrl(currentIcf.link) ? (
            <div className="flex flex-col items-center">
              <p className="mb-4">ICF document is available at the following link:</p>
              <a
                href={currentIcf.link}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:underline font-medium"
              >
                Open document in new tab
              </a>
              <div className="mt-6 w-full h-[500px] border border-gray-300 rounded-lg overflow-hidden">
                <iframe
                  src={currentIcf.link}
                  className="w-full h-full"
                  title={`ICF for ${currentIcf.name}`}
                  sandbox="allow-scripts allow-same-origin"
                />
              </div>
            </div>
          ) : (
            <div className="flex flex-col items-center">
              <div className="mb-6 text-center">
                <p className="text-lg font-medium mb-2">File: {currentIcf.link}</p>
                <p className="text-gray-600">
                  This file has been uploaded to the system. In a production environment, you would be able to download
                  or view this file directly.
                </p>
              </div>
              <div className="flex justify-center">
                <Button variant="addbutton" className="px-6 py-2">
                  Download Document
                </Button>
              </div>
            </div>
          )}
        </div>
      </Modal> */}
